/**
 * Remove a single empty line of text from Rich Text before components are rendered.
 *
 * @param {Array} content
 *
 * @returns {Boolean}
 */
const hasNoContent = content => content.length === 0 || (content.length === 1 && content[0]?.toString().match(/^\s?$/));

export default hasNoContent;
